import React from 'react';
import styled from '@emotion/styled';
import { TextSkeletons } from './HomePage';
import Skeleton from './Skeleton';
import breakpoints from '../Theme/breakpoints';

const ArticleGrid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 1100px;
  margin: 0 auto 1rem;
  width: 100%;
`;

const ArticleContainer = styled.div`
  display: block;
`;

const BreadcrumbGridItem = styled.div`
  flex-basis: 100%;
  flex-grow: 0;
  max-width: 100%;
  width: auto;
  padding: 0 0 1.25rem .75rem;
  box-sizing: border-box;
`;

const ArticleGridItem = styled.div`
  flex-basis: 100%;
  max-width: 100%;
  width: auto;
  padding: 0 .5rem 0;
  box-sizing: border-box;

  @media (min-width: ${breakpoints.lg}px) {
    flex-basis: 66.6667%;
    max-width: 66.6667%;
  }
`;

const SidebarGridItem = styled.div`
  display: none;

  @media (min-width: ${breakpoints.lg}px) {
    display: flex;
    flex-basis: 33.3333%;
    max-width: 33.3333%;
    width: auto;
    padding: 0 .5rem 0;
    box-sizing: border-box;
  }
`;

const ArticleHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

const ArticleSubContainerWrapper = styled.div`
  min-height: calc(50vh - 48px);
  margin: 0 0 12px;
  display: flex;
  flex-direction: row;

  @media (min-width: ${breakpoints.sm}px) {
    min-height: auto;
  }

  @media (min-width: ${breakpoints.md}px) {
    order: 1;
    margin: 2.25rem auto 0;
    min-width: 550px;
  }
`;

const SidebarContainer = styled.div`
  width: auto;
  min-height: 805px;
  padding: 0 16px 0;
`;

const RelatedProductsCards = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding-top: 1.5rem;
  margin-top: 1.5rem;
`;

const ImageSkeleton = styled(Skeleton)`
  width: 100%;
  height: 65vw;

  @media (min-width: ${breakpoints.lg}px) {
    height: 42vw;
  }
`;

const BreadcrumbSkeleton = styled(Skeleton)`
  width: 440px;  
`;

const HeaderSkeletons = styled.div`
  margin-bottom: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: calc(50vh - 100px);

  @media (min-width: ${breakpoints.sm}px) {
    min-height: auto;
  }
`;

const TextContainer = styled.div`
  max-width: 550px;
  padding: .5rem 0 1.25rem;
  margin: 1.5rem auto 0;

  @media (min-width: ${breakpoints.md}px) {
    padding: .75rem 1.5rem 1.5rem;
    margin: 0 auto;
  }
`;

const CardWithText = styled.div`
  width: 138px;
  display: inline-block;
  margin-top: 1.25rem;
`;

const SocialIcons = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
  gap: 1rem;
`;

const Credits = styled.div`
  display: block;
  flex: 1;
`;

const CardText = styled(Skeleton)`
  margin-left: auto;
  margin-right: auto;
`;

const SocialIconSkeleton = () => (
  <Skeleton variant="circular" width="30px" height="30px" />
);

const ArticleSubContainer = () => (
  <ArticleSubContainerWrapper>
    <Credits>
      <Skeleton width="25%" />
      <Skeleton width="40%" />
    </Credits>
    <SocialIcons>
      <SocialIconSkeleton />
      <SocialIconSkeleton />
      <SocialIconSkeleton />
      <SocialIconSkeleton />
      <SocialIconSkeleton />
    </SocialIcons>
  </ArticleSubContainerWrapper>
);

const CardWithTextSkeleton = () => (
  <CardWithText>
    <Skeleton height="184px" />
    <CardText width="75%" />
    <CardText width="60%" />
  </CardWithText>
);

const ArticleDetailSkeleton = () => (
  <ArticleGrid>
    <BreadcrumbGridItem>
      <BreadcrumbSkeleton />
    </BreadcrumbGridItem>
    <ArticleGridItem>
      <ArticleContainer>
        <ArticleHeader>
          <HeaderSkeletons>
            <Skeleton width="80%" height={32} />
            <Skeleton width="60%" height={32} />
          </HeaderSkeletons>
          <ArticleSubContainer />
          <ImageSkeleton />
        </ArticleHeader>
        <TextContainer>
          <TextSkeletons />
        </TextContainer>
      </ArticleContainer>
    </ArticleGridItem>
    <SidebarGridItem>
      <SidebarContainer>
        <Skeleton width="50%" />
        <RelatedProductsCards>
          <CardWithTextSkeleton />
          <CardWithTextSkeleton />
          <CardWithTextSkeleton />
          <CardWithTextSkeleton />
          <CardWithTextSkeleton />
          <CardWithTextSkeleton />
        </RelatedProductsCards>
      </SidebarContainer>
    </SidebarGridItem>
  </ArticleGrid>
);

export default ArticleDetailSkeleton;
